<template>
  <div class="form">
    <div class="is-horizontal">
      <div class="field-body">
        <text-field label="First name" v-model.trim="firstName" :error="firstNameError" />
        <text-field label="Last name" v-model.trim="lastName" :error="lastNameError" />
      </div>
    </div>
    <text-field label="Email" v-model.trim="email" :error="emailError" />
    <hirer-multiselect label="Company" v-model="company" placeholder="Select Companies" :options="this.companies"></hirer-multiselect>
  </div>
</template>

<script>
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import { mapMutations, mapState, mapActions } from 'vuex'
import TagSelect from '@/components/general/tag-select'
import HirerMultiselect from '@/components/hirer/hirer-multiselect'

export default {
  components: { Field, TextField, TagSelect, HirerMultiselect },
  computed: {
    ...mapState('adminCompanies', [
      'companies'
    ]),
    ...mapState('hirerForm', {
      formFistName: 'firstName',
      formLastName: 'lastName',
      formEmail: 'email',
      formCompany: 'company'
    }),
    companiesList () {
      if (this.companies === null) {
        return []
      }

      return this.companies.map(function (company) {
        return company.name
      })
    },
    firstName: {
      get () {
        return this.formFistName
      },
      set (value) {
        this.setFirstName(value)
      }
    },
    lastName: {
      get () {
        return this.formLastName
      },
      set (value) {
        this.setLastName(value)
      }
    },
    email: {
      get () {
        return this.formEmail
      },
      set (value) {
        this.setEmail(value)
      }
    },
    company: {
      get () {
        return this.formCompany
      },
      set (value) {
        this.setCompany(value)
      }
    }
  },
  methods: {
    ...mapActions('adminCompanies', [
      'getAll'
    ]),
    ...mapMutations('hirerForm', [
      'setFirstName',
      'setLastName',
      'setEmail',
      'setCompany'
    ])
  },
  data () {
    return {
      emailError: null,
      firstNameError: null,
      lastNameError: null,
      companyError: null
    }
  },
  mounted () {
    this.getAll()
  }
}
</script>

<style lang="scss" scoped>
.select {
    width: 100%;
    select {
      width: 100%;
    }
  }
  .compnaies {
    & /deep/ .select {
      .dropdown-menu {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/hirer/hirer-form.vue